import FD10 from '../../Images/FD10.PNG'
import Fittings from '../../Images/Fittings.jpg'

const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Laminar vs Turbulent velocity profiles ─────────────
function DiagramFlowRegimes() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Laminar vs Turbulent Velocity Profiles in a Circular Pipe</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrFR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrFRR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrFRG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrFRGr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* === Laminar (left panel) === */}
        <rect x="30" y="28" width="290" height="250" rx="8" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.2"/>
        <text x="175" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#2980b9">Laminar  (Re {'<'} 2300)</text>

        {/* Pipe walls */}
        <rect x="50" y="66" width="250" height="10" rx="3" fill="#7B0D0D" opacity="0.45"/>
        <rect x="50" y="212" width="250" height="10" rx="3" fill="#7B0D0D" opacity="0.45"/>

        {/* Parabolic profile arrows */}
        {[-1,-0.8,-0.6,-0.4,-0.2,0,0.2,0.4,0.6,0.8,1.0].map((eta, i) => {
          const cy = 143;
          const halfH = 73;
          const y = cy + eta * halfH;
          const len = Math.round((1 - eta*eta) * 110);
          if (len < 4) return null;
          return (
            <line key={i} x1="60" y1={y} x2={60 + len} y2={y}
              stroke="#2980b9" strokeWidth={0.8 + (1 - Math.abs(eta)) * 1.6}
              markerEnd="url(#arrFR)" opacity="0.80"/>
          );
        })}

        {/* Parabola envelope */}
        <path d="M 60 76 Q 170 143 60 212" fill="none" stroke="#7B0D0D" strokeWidth="1.4" strokeDasharray="5 3"/>

        {/* u_max label */}
        <text x="180" y="147" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D" fontWeight="700">u_max = 2V̄</text>

        {/* R annotation */}
        <line x1="34" y1="76"  x2="34" y2="216" stroke="#27ae60" strokeWidth="1"
          markerEnd="url(#arrFRG)" markerStart="url(#arrFRGr)"/>
        <text x="22" y="148" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#27ae60">2R</text>

        {/* Formula */}
        <rect x="50" y="228" width="250" height="38" rx="5" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="175" y="244" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">u(r) = u_max(1 − r²/R²)</text>
        <text x="175" y="260" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">parabolic;  f = 64/Re</text>

        {/* === Turbulent (right panel) === */}
        <rect x="360" y="28" width="290" height="250" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="505" y="50" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Turbulent  (Re {'>'} 4000)</text>

        {/* Pipe walls */}
        <rect x="380" y="66" width="250" height="10" rx="3" fill="#7B0D0D" opacity="0.45"/>
        <rect x="380" y="212" width="250" height="10" rx="3" fill="#7B0D0D" opacity="0.45"/>

        {/* Flatter (power-law) profile arrows */}
        {[-1,-0.8,-0.6,-0.4,-0.2,0,0.2,0.4,0.6,0.8,1.0].map((eta, i) => {
          const cy = 143;
          const halfH = 73;
          const y = cy + eta * halfH;
          const absEta = Math.abs(eta);
          const len = absEta > 0.97 ? 4 : Math.round(Math.pow(1 - absEta, 1/7) * 108);
          if (len < 4) return null;
          return (
            <line key={i} x1="390" y1={y} x2={390 + len} y2={y}
              stroke="#c0392b" strokeWidth={0.8 + (1 - absEta) * 1.2}
              markerEnd="url(#arrFRR)" opacity="0.80"/>
          );
        })}

        {/* Turbulent envelope */}
        <path d="M 390 76 Q 500 143 390 212" fill="none" stroke="#7B0D0D" strokeWidth="1.4" strokeDasharray="5 3"/>

        {/* Flat core indication */}
        <line x1="390" y1="100" x2="500" y2="100" stroke="#c0392b" strokeWidth="0.5" strokeDasharray="2 2" opacity="0.4"/>
        <line x1="390" y1="186" x2="500" y2="186" stroke="#c0392b" strokeWidth="0.5" strokeDasharray="2 2" opacity="0.4"/>
        <text x="516" y="148" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D" fontWeight="700">u_max ≈ 1.2V̄</text>

        {/* Formula */}
        <rect x="380" y="228" width="250" height="38" rx="5" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1"/>
        <text x="505" y="244" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#2980b9">u(r) ≈ u_max(1−r/R)^(1/n)</text>
        <text x="505" y="260" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">power-law;  n≈7 at Re≈10⁵</text>
      </svg>
      <div style={S.dCaption}>
        Laminar flow (left): smooth parabolic profile, u_max = 2V̄ at centreline, zero velocity at wall (no-slip).
        Turbulent flow (right): flatter power-law profile from vigorous mixing, u_max ≈ 1.2V̄.
        The transition from laminar to turbulent occurs around Re = 2300–4000 for pipe flow.
      </div>
    </div>
  );
}

// ── Diagram 2: Moody Diagram (schematic) ──────────────────────────
function DiagramMoody() {
  const W = 680, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Moody Diagram — Friction Factor vs Reynolds Number</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrMD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
        </defs>

        {/* Axes */}
        <line x1="80" y1="260" x2="650" y2="260" stroke="#888" strokeWidth="1.2" markerEnd="url(#arrMD)"/>
        <line x1="80" y1="260" x2="80"  y2="28"  stroke="#888" strokeWidth="1.2" markerEnd="url(#arrMD)"/>
        <text x="668" y="264" fontFamily="Georgia,serif" fontSize="12" fill="#555">Re</text>
        <text x="56"  y="22"  fontFamily="Georgia,serif" fontSize="12" fill="#555">f</text>

        {/* Log-scale Re axis labels */}
        {[
          {x:112, label:'10³'},
          {x:190, label:'10⁴'},
          {x:295, label:'10⁵'},
          {x:400, label:'10⁶'},
          {x:505, label:'10⁷'},
          {x:610, label:'10⁸'},
        ].map(({x, label}) => (
          <g key={x}>
            <line x1={x} y1="258" x2={x} y2="264" stroke="#888" strokeWidth="1"/>
            <text x={x} y="276" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#666">{label}</text>
          </g>
        ))}

        {/* f axis labels */}
        {[
          {y:248, label:'0.01'},
          {y:200, label:'0.02'},
          {y:158, label:'0.04'},
          {y:118, label:'0.08'},
          {y: 82, label:'0.15'},
        ].map(({y, label}) => (
          <g key={y}>
            <line x1="78" y1={y} x2="84" y2={y} stroke="#888" strokeWidth="1"/>
            <text x="72" y={y+4} textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#666">{label}</text>
          </g>
        ))}

        {/* Grid lines */}
        {[248,200,158,118,82].map(y => (
          <line key={y} x1="80" y1={y} x2="648" y2={y} stroke="#eee" strokeWidth="0.7"/>
        ))}
        {[112,190,295,400,505,610].map(x => (
          <line key={x} x1={x} y1="28" x2={x} y2="260" stroke="#eee" strokeWidth="0.7"/>
        ))}

        {/* Laminar line: f = 64/Re  (log-log → straight line) */}
        {/* Re=1e3→f=0.064, Re=2300→f=0.028 */}
        <line x1="112" y1="142" x2="166" y2="210"
          stroke="#2980b9" strokeWidth="2.5"/>
        <text x="88" y="130" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#2980b9">f = 64/Re</text>
        <text x="88" y="144" fontFamily="Georgia,serif" fontSize="10" fill="#2980b9" fontStyle="italic">(laminar)</text>

        {/* Transition zone band */}
        <rect x="166" y="28" width="36" height="232" fill="#f0cece" opacity="0.35"/>
        <text x="184" y="290" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b" fontStyle="italic">transition</text>
        <text x="184" y="302" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">2300–4000</text>

        {/* Turbulent smooth pipe (Blasius) */}
        {/* From Re=4000, f≈0.040 curving down toward Re=1e8, f≈0.008 */}
        <path d="M 202 188 C 280 170 360 148 450 132 C 530 118 600 108 648 102"
          fill="none" stroke="#27ae60" strokeWidth="2" strokeDasharray="7 3"/>
        <text x="530" y="96" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60" fontStyle="italic">smooth pipe</text>

        {/* Fully rough lines (horizontal asymptotes at high Re) */}
        {/* ε/D = 0.001 */}
        <path d="M 295 148 C 360 142 430 128 648 122"
          fill="none" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="652" y="120" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">ε/D=0.001</text>

        {/* ε/D = 0.01 */}
        <path d="M 240 174 C 295 162 370 148 648 140"
          fill="none" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="652" y="138" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">ε/D=0.01</text>

        {/* ε/D = 0.05 */}
        <path d="M 202 192 C 260 182 330 168 648 162"
          fill="none" stroke="#c0392b" strokeWidth="1.5"/>
        <text x="652" y="160" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">ε/D=0.05</text>

        {/* "Fully rough" region label */}
        <text x="580" y="46" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b" fontStyle="italic">fully rough</text>
        <text x="580" y="58" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b" fontStyle="italic">(f independent of Re)</text>

        {/* Colebrook label */}
        <rect x="290" y="280" width="260" height="30" rx="5" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="420" y="300" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">
          1/√f = −2 log(ε/3.7D + 2.51/(Re√f))
        </text>
      </svg>
      <div style={S.dCaption}>
        Schematic Moody diagram. Blue: laminar zone (f = 64/Re, straight on log-log). Green dashed: smooth-pipe turbulent curve.
        Red curves: constant relative roughness ε/D lines that flatten to horizontal at high Re (fully rough regime, f independent of Re).
        The Colebrook-White equation (bottom) describes the entire turbulent region.
      </div>
    </div>
  );
}

// ── Diagram 3: Entrance length & fully-developed flow ─────────────
function DiagramEntranceLength() {
  const W = 680, H = 270;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Entrance Region &amp; Fully-Developed Flow in a Pipe</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrEL" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrELR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrELG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrELGr" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* Pipe walls */}
        <line x1="60"  y1="80"  x2="640" y2="80"  stroke="#7B0D0D" strokeWidth="2.5"/>
        <line x1="60"  y1="190" x2="640" y2="190" stroke="#7B0D0D" strokeWidth="2.5"/>

        {/* Fluid fill background */}
        <rect x="60" y="80" width="580" height="110" fill="#2980b9" opacity="0.07"/>

        {/* Boundary layers growing from walls */}
        {/* Top boundary layer */}
        <path d="M 60 80 Q 200 80 260 92 Q 310 102 340 135"
          fill="none" stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5 3"/>
        {/* Bottom boundary layer */}
        <path d="M 60 190 Q 200 190 260 178 Q 310 168 340 135"
          fill="none" stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5 3"/>

        {/* Inviscid core arrow (flat profile in entry region) */}
        <line x1="72"  y1="135" x2="144" y2="135" stroke="#2980b9" strokeWidth="2.4" markerEnd="url(#arrEL)"/>
        <line x1="72"  y1="110" x2="144" y2="110" stroke="#2980b9" strokeWidth="1.6" markerEnd="url(#arrEL)" opacity="0.6"/>
        <line x1="72"  y1="160" x2="144" y2="160" stroke="#2980b9" strokeWidth="1.6" markerEnd="url(#arrEL)" opacity="0.6"/>
        <text x="66" y="70" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">uniform inlet</text>

        {/* Developing profile (intermediate) */}
        {[-0.65,-0.3,0,0.3,0.65].map((eta, i) => {
          const y = 135 + eta * 50;
          const len = 14 + (1-Math.abs(eta)*0.7)*36;
          return (
            <line key={i} x1="200" y1={y} x2={200+len} y2={y}
              stroke="#2980b9" strokeWidth={1 + (1-Math.abs(eta))*0.8} markerEnd="url(#arrEL)" opacity="0.75"/>
          );
        })}

        {/* Fully developed parabolic profile (right) */}
        {[-1,-0.75,-0.5,-0.25,0,0.25,0.5,0.75,1].map((eta, i) => {
          const y = 135 + eta * 55;
          const len = Math.round((1 - eta*eta) * 100);
          if (len < 4) return null;
          return (
            <line key={i} x1="430" y1={y} x2={430+len} y2={y}
              stroke="#2980b9" strokeWidth={0.8+(1-Math.abs(eta))*1.6}
              markerEnd="url(#arrEL)" opacity="0.85"/>
          );
        })}
        <path d="M 430 84 Q 530 135 430 188" fill="none" stroke="#7B0D0D" strokeWidth="1.4" strokeDasharray="5 3"/>
        <text x="540" y="120" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D" fontWeight="700">u_max=2V̄</text>

        {/* L_e annotation */}
        <line x1="60"  y1="218" x2="380" y2="218" stroke="#27ae60" strokeWidth="1.2"
          markerEnd="url(#arrELG)" markerStart="url(#arrELGr)"/>
        <text x="220" y="235" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#27ae60">L_e  (entrance length)</text>

        {/* Formulae box */}
        <rect x="380" y="210" width="260" height="48" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="510" y="228" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">Laminar:    L_e/D ≈ 0.06 Re</text>
        <text x="510" y="248" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">Turbulent:  L_e/D ≈ 4.4 Re^(1/6)</text>

        {/* Boundary layer label */}
        <text x="170" y="72" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b" fontStyle="italic">growing boundary layer</text>

        {/* Fully developed label */}
        <text x="520" y="72" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D" fontWeight="700">fully developed</text>
        <line x1="380" y1="80" x2="380" y2="200" stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4 3"/>
      </svg>
      <div style={S.dCaption}>
        Near the pipe entry the velocity is nearly uniform and boundary layers grow inward from the wall.
        Once the boundary layers merge at the centreline the profile stops changing — the flow is fully developed.
        Entrance length L_e is much longer for laminar flow (L_e/D ≈ 0.06 Re) than turbulent (L_e/D ≈ 4.4 Re^1/6).
      </div>
    </div>
  );
}

// ── Diagram 4: Minor Losses — expansion, contraction, bend ────────
function DiagramMinorLosses() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Minor Losses — Sudden Expansion, Contraction &amp; Pipe Bend</div>
                  <h2>Head Loss Due to Flow</h2>
                        A “Head” in regards to a hydraulic system is the measurement of fluid pressure above a vertical datum. Head loss is
                         the process of potential energy within a fluid being converted to kinetic due to frictional resistances found throughout
                          a pipe/tube system. This system includes the pipe, valves, fittings, entrance and exit. Head loss is often high enough
                           that it cannot be ignored in flow calculations. Its values largely depend on the square of the flow rate. 
                           <br />
                        <br /> 
The head loss due to friction (H_f) is usually determined by the Darcy-Weisbach equation. This equation uses the dimensionless factor f which 
is a function of the Reynold’s number. L is the length over which the pressure drop occurs, D is the diameter of the pipe and v is the velocity
 of the fluid flow. Losses also occur as the fluid flows through pipe fittings, elbows, valves, couplings and sudden pipe contractions and 
 expansions.
       <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={FD10} alt="linkages" width="35%"/>
                                </div>
                                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={Fittings} alt="linkages" width="75%"/>
                                </div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrML" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrMLR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ── Sudden Expansion (top-left) ── */}
        <text x="152" y="28" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Sudden Expansion</text>
        {/* Pipe walls */}
        <path d="M 30 44  L 130 44  L 130 72  L 280 72"  fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        <path d="M 30 90  L 130 90  L 130 118 L 280 118" fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        {/* Fluid */}
        <path d="M 30 44 L 130 44 L 130 72 L 280 72 L 280 118 L 130 118 L 130 90 L 30 90 Z"
          fill="#2980b9" opacity="0.10"/>
        {/* Recirculation zone */}
        <path d="M 130 72 Q 160 82 160 95 Q 160 108 130 118"
          fill="#c0392b" opacity="0.12"/>
        <path d="M 135 76 C 155 80 162 90 155 104 C 148 116 136 116 130 116"
          fill="none" stroke="#c0392b" strokeWidth="1.2" strokeDasharray="3 2" markerEnd="url(#arrMLR)"/>
        <text x="170" y="96" fontFamily="Georgia,serif" fontSize="9" fill="#c0392b" fontStyle="italic">separation / recirculation</text>
        {/* Flow arrows */}
        <line x1="42" y1="67"  x2="84"  y2="67"  stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrML)"/>
        <line x1="196" y1="95" x2="252" y2="95" stroke="#2980b9" strokeWidth="1.5" markerEnd="url(#arrML)" opacity="0.7"/>
        {/* K label */}
        <rect x="30" y="126" width="250" height="24" rx="4" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="155" y="142" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">h_L = (V₁−V₂)²/2g  (Borda-Carnot)</text>

        {/* ── Sudden Contraction (top-right) ── */}
        <text x="500" y="28" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">Sudden Contraction</text>
        {/* Pipe walls */}
        <path d="M 368 44 L 500 44 L 500 68 L 640 68"  fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        <path d="M 368 118 L 500 118 L 500 94 L 640 94" fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        {/* Fluid */}
        <path d="M 368 44 L 500 44 L 500 68 L 640 68 L 640 94 L 500 94 L 500 118 L 368 118 Z"
          fill="#2980b9" opacity="0.10"/>
        {/* Vena contracta */}
        <path d="M 500 68 Q 520 78 522 81 Q 524 84 522 87 Q 520 90 500 94"
          fill="#c0392b" opacity="0.15"/>
        {/* Converging streamlines */}
        <path d="M 450 50 Q 490 65 500 68" fill="none" stroke="#2980b9" strokeWidth="1.2" strokeDasharray="3 2" markerEnd="url(#arrML)" opacity="0.6"/>
        <path d="M 450 112 Q 490 97 500 94" fill="none" stroke="#2980b9" strokeWidth="1.2" strokeDasharray="3 2" markerEnd="url(#arrML)" opacity="0.6"/>
        <text x="528" y="76" fontFamily="Georgia,serif" fontSize="9" fill="#c0392b" fontStyle="italic">vena contracta</text>
        <line x1="598" y1="81" x2="640" y2="81" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrML)" opacity="0.75"/>
        {/* K label */}
        <rect x="368" y="126" width="272" height="24" rx="4" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1"/>
        <text x="504" y="142" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#2980b9">h_L = K V₂²/2g   K ≈ 0.5 (sharp)</text>

        {/* ── Pipe Bend (bottom) ── */}
        <text x="340" y="178" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#7B0D0D">90° Pipe Bend — Loss Coefficient K</text>
        {/* Bend shape */}
        <path d="M 100 198 L 240 198 Q 300 198 300 258 L 300 286"
          fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        <path d="M 100 222 L 240 222 Q 276 222 276 258 L 276 286"
          fill="none" stroke="#7B0D0D" strokeWidth="2"/>
        {/* Fluid */}
        <path d="M 100 198 L 240 198 Q 300 198 300 258 L 300 286 L 276 286 L 276 258 Q 276 222 240 222 L 100 222 Z"
          fill="#2980b9" opacity="0.10"/>
        <line x1="115" y1="210" x2="180" y2="210" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrML)"/>
        <line x1="288" y1="270" x2="288" y2="280" stroke="#2980b9" strokeWidth="1.8" markerEnd="url(#arrML)"/>
        {/* K table for bends */}
        <rect x="340" y="188" width="310" height="96" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x="495" y="208" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#7B0D0D">Typical K values for fittings</text>
        <line x1="350" y1="215" x2="640" y2="215" stroke="#f0cece" strokeWidth="1"/>
        <text x="495" y="230" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">Sharp 90° bend: K ≈ 1.1–1.5</text>
        <text x="495" y="246" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">Long-radius 90° elbow: K ≈ 0.3</text>
        <text x="495" y="262" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">Globe valve (fully open): K ≈ 6–10</text>
        <text x="495" y="278" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill="#555">Gate valve (fully open): K ≈ 0.1</text>
      </svg>
      <div style={S.dCaption}>
        Minor losses arise from geometry changes. Sudden expansion: energy lost to turbulent recirculation (Borda-Carnot formula, exact for sudden expansion).
        Sudden contraction: vena contracta forms downstream of the corner, then re-expands; K ≈ 0.5.
        Bends and fittings are characterised by a loss coefficient K, where h_L = K V²/2g.
      </div>
    </div>
  );
}

// ── Diagram 5: EGL/HGL with friction and minor losses ─────────────
function DiagramEGLWithLosses() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Energy Grade Line — Friction &amp; Minor Losses Along a Pipe System</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrEG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrEGB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrEGV" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrEGVT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Datum */}
        <line x1="40" y1="258" x2="644" y2="258" stroke="#aaa" strokeWidth="1" strokeDasharray="4 3"/>
        <text x="46" y="272" fontFamily="Georgia,serif" fontSize="10" fill="#888" fontStyle="italic">datum</text>

        {/* Pipe (two diameters) */}
        <path d="M 50 200 L 240 200 L 240 188 L 540 188 L 540 200 L 640 200"
          fill="none" stroke="#7B0D0D" strokeWidth="2.2" strokeLinecap="round"/>
        <path d="M 50 220 L 240 220 L 240 230 L 540 230 L 540 220 L 640 220"
          fill="none" stroke="#7B0D0D" strokeWidth="2.2" strokeLinecap="round"/>
        <path d="M 50 200 L 240 200 L 240 188 L 540 188 L 540 200 L 640 200 L 640 220 L 540 220 L 540 230 L 240 230 L 240 220 L 50 220 Z"
          fill="#2980b9" opacity="0.09"/>

        {/* EGL — sloping down with drops at fittings */}
        {/* Entrance drop */}
        <line x1="50"  y1="60"  x2="50"  y2="74"  stroke="#c0392b" strokeWidth="2.2"/>
        {/* Friction slope section 1 */}
        <line x1="50"  y1="74"  x2="240" y2="112" stroke="#c0392b" strokeWidth="2.2"/>
        {/* Sudden expansion drop */}
        <line x1="240" y1="112" x2="240" y2="126" stroke="#c0392b" strokeWidth="2.2"/>
        {/* Friction slope section 2 (wider pipe, less slope) */}
        <line x1="240" y1="126" x2="540" y2="148" stroke="#c0392b" strokeWidth="2.2"/>
        {/* Valve drop */}
        <line x1="540" y1="148" x2="540" y2="174" stroke="#c0392b" strokeWidth="2.2"/>
        {/* Friction slope section 3 */}
        <line x1="540" y1="174" x2="640" y2="188" stroke="#c0392b" strokeWidth="2.2"/>
        <text x="652" y="192" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#c0392b">EGL</text>

        {/* HGL (EGL - V²/2g) */}
        {/* Section 1 narrow → large gap */}
        <line x1="50"  y1="88"  x2="240" y2="126" stroke="#2980b9" strokeWidth="1.8" strokeDasharray="6 3"/>
        {/* After expansion — gap narrows (lower V) */}
        <line x1="240" y1="134" x2="540" y2="156" stroke="#2980b9" strokeWidth="1.8" strokeDasharray="6 3"/>
        {/* After valve */}
        <line x1="540" y1="182" x2="640" y2="196" stroke="#2980b9" strokeWidth="1.8" strokeDasharray="6 3"/>
        <text x="652" y="200" fontFamily="Georgia,serif" fontSize="11" fontWeight="700" fill="#2980b9">HGL</text>

        {/* V²/2g gap annotation at section 1 */}
        <line x1="140" y1="102" x2="140" y2="116" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrEGV)" markerStart="url(#arrEGVT)"/>
        <text x="152" y="112" fontFamily="Courier New,monospace" fontSize="9" fill="#555">V₁²/2g</text>

        {/* V²/2g gap annotation at section 2 */}
        <line x1="380" y1="139" x2="380" y2="148" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrEGV)" markerStart="url(#arrEGVT)"/>
        <text x="392" y="147" fontFamily="Courier New,monospace" fontSize="9" fill="#555">V₂²/2g</text>

        {/* Drop labels */}
        <text x="30"  y="70" textAnchor="end" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">h_entry</text>
        <text x="222" y="122" textAnchor="end" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">h_exp</text>
        <text x="522" y="165" textAnchor="end" fontFamily="Courier New,monospace" fontSize="9" fill="#c0392b">h_valve</text>

        {/* Friction slope arrows */}
        <text x="135" y="72" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#7B0D0D" fontStyle="italic">slope = f/D · V₁²/2g</text>
        <text x="388" y="108" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#7B0D0D" fontStyle="italic">slope = f/D · V₂²/2g</text>
      </svg>
      <div style={S.dCaption}>
        The EGL (red solid) slopes downward everywhere due to friction; steeper slope in the narrow section (higher V and f slope).
        Sudden drops occur at entrance, expansion, and valve (minor losses). The HGL (blue dashed) runs below EGL by the velocity head V²/2g.
        The gap between HGL and EGL widens in the narrow pipe (higher velocity) and narrows in the wide pipe.
      </div>
    </div>
  );
}

// ── Diagram 6: Pipe systems — series & parallel ───────────────────
function DiagramPipeSystems() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pipe Systems — Series vs Parallel Configuration</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrPS" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2980b9"/>
          </marker>
          <marker id="arrPSR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* ── Series (top) ── */}
        <text x="340" y="24" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Series Pipes</text>

        {/* Pipe 1 */}
        <rect x="40"  y="36" width="150" height="26" rx="4" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="115" y="53" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">Pipe 1 (D₁, L₁, f₁)</text>
        {/* Pipe 2 */}
        <rect x="265" y="36" width="150" height="26" rx="4" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="340" y="53" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">Pipe 2 (D₂, L₂, f₂)</text>
        {/* Pipe 3 */}
        <rect x="490" y="36" width="150" height="26" rx="4" fill="#EAF3FF" stroke="#2980b9" strokeWidth="1.5"/>
        <text x="565" y="53" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9">Pipe 3 (D₃, L₃, f₃)</text>
        {/* Connectors */}
        <line x1="190" y1="49" x2="265" y2="49" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrPS)"/>
        <line x1="415" y1="49" x2="490" y2="49" stroke="#2980b9" strokeWidth="2" markerEnd="url(#arrPS)"/>

        {/* Flow Q label */}
        <line x1="40" y1="49" x2="40" y2="49" stroke="none"/>
        <text x="22" y="53" textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9" fontWeight="700">Q →</text>
        <text x="658" y="53" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9" fontWeight="700">→ Q</text>

        {/* Series rules */}
        <rect x="40" y="72" width="600" height="42" rx="5" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="340" y="89" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">Q₁ = Q₂ = Q₃ = Q  (same flow rate)</text>
        <text x="340" y="106" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#7B0D0D">h_L,total = h_L1 + h_L2 + h_L3  (heads add)</text>

        {/* ── Parallel (bottom) ── */}
        <text x="340" y="138" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Parallel Pipes</text>

        {/* Junction nodes */}
        <circle cx="100" cy="210" r="7" fill="#7B0D0D"/>
        <circle cx="580" cy="210" r="7" fill="#7B0D0D"/>
        <text x="100" y="232" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Junction A</text>
        <text x="580" y="232" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">Junction B</text>

        {/* Inlet / outlet Q */}
        <line x1="44"  y1="210" x2="90"  y2="210" stroke="#2980b9" strokeWidth="2.4" markerEnd="url(#arrPS)"/>
        <text x="30" y="207" textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9" fontWeight="700">Q</text>
        <line x1="590" y1="210" x2="636" y2="210" stroke="#2980b9" strokeWidth="2.4" markerEnd="url(#arrPS)"/>
        <text x="648" y="213" fontFamily="Courier New,monospace" fontSize="11" fill="#2980b9" fontWeight="700">Q</text>

        {/* Three parallel pipes */}
        {[
          {y:168, label:'Pipe A  (D_A, L_A, f_A)  →  Q_A', color:'#2980b9'},
          {y:210, label:'Pipe B  (D_B, L_B, f_B)  →  Q_B', color:'#27ae60'},
          {y:252, label:'Pipe C  (D_C, L_C, f_C)  →  Q_C', color:'#c0392b'},
        ].map(({y, label, color}) => (
          <g key={y}>
            <line x1="107" y1={y} x2="573" y2={y} stroke={color} strokeWidth="2" markerEnd="url(#arrPS)"/>
            <text x="340" y={y-6} textAnchor="middle" fontFamily="Courier New,monospace" fontSize="10" fill={color}>{label}</text>
          </g>
        ))}

        {/* Parallel rules */}
        <rect x="40" y="264" width="600" height="20" rx="4" fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x="340" y="278" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fontWeight="700" fill="#27ae60">h_LA = h_LB = h_LC  (same head loss)     Q = Q_A + Q_B + Q_C  (flows add)</text>
      </svg>
      <div style={S.dCaption}>
        Series pipes: the same flow Q passes through each pipe; total head loss is the sum of individual losses. Used to find operating point for a given Q.
        Parallel pipes: each branch has the same head loss (A to B); total flow is the sum of branch flows. Solved iteratively or by substitution.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function PipeFlowAndLosses() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Pipe Flow &amp; Losses</h1>
      <p style={S.p}>
        Internal flow through pipes and ducts is the most common problem in engineering fluid mechanics.
        The analysis combines the Reynolds number criterion for flow regime, the Darcy-Weisbach equation
        for friction losses, the Moody diagram for the friction factor, and loss coefficients for
        fittings — all assembled via the extended Bernoulli (energy) equation.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Reynolds number — Re = ρVD/μ; governs laminar (Re < 2300), transition, and turbulent (Re > 4000) regimes",
        "Velocity profiles — parabolic in laminar flow (u_max = 2V̄); flatter power-law in turbulent flow",
        "Darcy-Weisbach — h_f = f(L/D)(V²/2g); the universal friction-loss formula for any flow regime",
        "Moody diagram — friction factor f as a function of Re and relative roughness ε/D",
        "Minor losses — h_m = KV²/2g; loss coefficients K for entrances, bends, expansions, valves",
        "EGL and HGL — graphical tool showing head budget; EGL drops continuously, HGL tracks pressure head",
        "Pipe systems — series (equal Q, heads add) and parallel (equal head loss, flows add)",
      ]}/>

      {/* ── Reynolds Number & Flow Regimes ── */}
      <h2 style={S.h2}>Reynolds Number &amp; Flow Regimes</h2>
      <p style={S.p}>
        The Reynolds number Re = ρVD/μ is the fundamental parameter that determines whether pipe flow
        is laminar, transitional, or turbulent. It represents the ratio of inertial to viscous forces.
        All downstream analysis — friction factor, velocity profile, heat transfer — depends on the regime.
      </p>
      <DiagramFlowRegimes/>
      <Table2 rows={[
        ["Reynolds number",
`Re = ρVD/μ = VD/ν  (dimensionless)
V = mean velocity [m/s],  D = pipe diameter [m]
μ = dynamic viscosity [Pa·s],  ν = kinematic viscosity [m²/s]`],
        ["Flow regimes in pipes",
`Re < 2300     → laminar:      smooth, ordered layers
2300 < Re < 4000 → transitional: unstable, sensitive to disturbances
Re > 4000     → turbulent:    chaotic mixing, eddies
Critical Re ≈ 2300 (lower critical) to 4000 (upper critical)`],
        ["Laminar velocity profile",
`Exact N-S solution: u(r) = u_max(1 − r²/R²)   (paraboloid)
u_max = 2V̄   (centreline is twice the mean)
Wall shear: τ_w = 4μV̄/R = 8μV̄/D
Friction factor: f = 64/Re  (Darcy-Weisbach)`],
        ["Turbulent velocity profile",
`Power-law: u(r) ≈ u_max(1 − r/R)^(1/n)
n ≈ 7 at Re ≈ 10⁵;  n increases with Re (flatter profile)
u_max/V̄ ≈ 1.2  (much less peaked than laminar)
Log-law (wall region): u⁺ = (1/κ)ln(y⁺) + B,  κ ≈ 0.41, B ≈ 5.0`],
        ["Hydraulic diameter D_h",
`D_h = 4A/P  (A = cross-section area, P = wetted perimeter)
Circular pipe: D_h = D
Rectangle a×b: D_h = 2ab/(a+b)
Use D_h in Re and Darcy-Weisbach for non-circular ducts`],
      ]}/>

      {/* ── Darcy-Weisbach & Friction Factor ── */}
      <h2 style={S.h2}>Darcy-Weisbach Equation &amp; Friction Factor</h2>
      <p style={S.p}>
        The Darcy-Weisbach equation is the universal formula for major (friction) head loss in a pipe.
        The Darcy friction factor f is dimensionless and depends on Re and relative roughness ε/D.
        It is read from the Moody diagram or calculated from the Colebrook-White equation.
      </p>
      <DiagramMoody/>
      <Table2 rows={[
        ["Darcy-Weisbach equation",
`h_f = f · (L/D) · V²/(2g)   [m of head]
f = Darcy friction factor (dimensionless)
L = pipe length [m],  D = pipe diameter [m]
Pressure drop form: ΔP = f · (L/D) · ½ρV²`],
        ["Laminar friction factor",
`f = 64/Re   (exact analytical result from Hagen-Poiseuille)
Independent of pipe roughness for laminar flow
Valid only for Re < 2300`],
        ["Colebrook-White (turbulent)",
`1/√f = −2.0 log(ε/(3.7D) + 2.51/(Re√f))
Implicit — requires iteration or solver
ε = pipe roughness height [m]: commercial steel ε ≈ 0.046 mm
Cast iron ε ≈ 0.26 mm;  drawn tubing ε ≈ 0.0015 mm`],
        ["Swamee-Jain (explicit approx.)",
`f = 0.25 / [log(ε/(3.7D) + 5.74/Re^0.9)]²
Explicit — no iteration needed
Accurate to ±3% for 10⁻⁶ < ε/D < 10⁻² and 5000 < Re < 10⁸`],
        ["Fully rough regime",
`When Re√f >> 2.51/(ε/3.7D): Colebrook → 1/√f = −2 log(ε/3.7D)
f depends only on ε/D — independent of Re
f = 0.25/[log(3.7D/ε)]²  (von Kármán rough-pipe formula)`],
        ["Relative roughness ε/D",
`Key parameter for turbulent friction factor
Smooth pipe: ε/D → 0  (f follows smooth-pipe curve)
Commercial steel: ε/D ≈ 0.046/D mm
As Re increases, even smooth-looking pipes behave "rough"`],
      ]}/>

      {/* ── Entrance Length ── */}
      <h2 style={S.h2}>Entrance Region &amp; Fully-Developed Flow</h2>
      <p style={S.p}>
        At the pipe entrance, the velocity profile is not yet fully developed — boundary layers grow
        from the walls and the centreline velocity increases until they merge. Only beyond the entrance
        length L_e does the profile become constant and the Darcy-Weisbach equation apply strictly.
      </p>
      <DiagramEntranceLength/>
      <Table2 rows={[
        ["Entrance length (laminar)",
`L_e/D ≈ 0.06 Re
For Re = 2000:  L_e ≈ 120 D  (very long entrance region)
Profile developing region has higher friction than fully-developed`],
        ["Entrance length (turbulent)",
`L_e/D ≈ 4.4 Re^(1/6)
For Re = 10⁵:  L_e ≈ 30 D  (much shorter relative to laminar)
Turbulent mixing accelerates profile development`],
        ["Fully-developed flow conditions",
`Velocity profile unchanging: ∂u/∂x = 0 (but u = u(r) still)
Pressure gradient constant: dP/dx = const < 0
Wall shear stress constant along pipe
Energy equation reduces to: Δh = h_f = f(L/D)(V²/2g)`],
        ["Entry pressure drop",
`Extra pressure drop in entrance region vs fully-developed
Accounted for by equivalent length or entry loss K_entry
Sharp-edged entry: K ≈ 0.5;  bell-mouth entry: K ≈ 0.04
Reentrant (protruding) entry: K ≈ 0.8–1.0`],
      ]}/>

      {/* ── Minor Losses ── */}
      <h2 style={S.h2}>Minor Losses</h2>
      <p style={S.p}>
        Minor losses occur at any change in pipe geometry — entrances, exits, expansions, contractions,
        bends, tees, and valves. Although called "minor", in short pipe systems with many fittings they
        can dominate over friction losses. Each fitting is characterised by a loss coefficient K.
      </p>
      <DiagramMinorLosses/>
      <Table2 rows={[
        ["General minor loss formula",
`h_m = K · V²/(2g)   [m]
K = loss coefficient (dimensionless, from tables or experiment)
V = velocity in the pipe downstream of the fitting
ΔP_minor = K · ½ρV²`],
        ["Sudden expansion (exact)",
`h_L = (V₁ − V₂)²/(2g)   (Borda-Carnot equation — exact)
K_exp = (1 − A₁/A₂)²  (based on upstream velocity V₁)
Exit to large reservoir (A₂→∞): K = 1.0, all kinetic energy lost`],
        ["Sudden contraction (approximate)",
`h_L = K · V₂²/(2g)
Sharp-edged: K ≈ 0.5;  slightly rounded: K ≈ 0.3
K derived from vena contracta coefficient: K = (1/C_c − 1)²
C_c = A_vena/A_pipe ≈ 0.61 for sharp edge`],
        ["Pipe entrance losses",
`Sharp-edged (flush): K ≈ 0.5
Well-rounded (bell-mouth): K ≈ 0.03–0.05
Re-entrant (protruding into reservoir): K ≈ 0.8–1.0
Loss based on pipe velocity head V²/2g`],
        ["Bends and elbows",
`h_m = K · V²/(2g)
Sharp 90° miter bend:       K ≈ 1.1
Standard 90° screwed elbow: K ≈ 0.9
Long-radius 90° elbow:      K ≈ 0.2–0.4
180° return bend:           K ≈ 1.5`],
        ["Valves",
`Globe valve (open):   K ≈ 6–10  (high loss — flow turns 180°)
Gate valve (open):    K ≈ 0.1–0.2
Ball valve (open):    K ≈ 0.05
Butterfly valve (open): K ≈ 0.3–1.0  (varies with disc angle)
Check valve:          K ≈ 2.0–5.0`],
        ["Equivalent length method",
`h_m = f · (L_eq/D) · V²/(2g)   where L_eq = KD/f
Replaces fitting with an equivalent pipe length
Useful for combining minor and major losses in a single calculation`],
      ]}/>

      {/* ── EGL with losses ── */}
      <h2 style={S.h2}>EGL &amp; HGL with Friction and Minor Losses</h2>
      <p style={S.p}>
        The Energy Grade Line (EGL) and Hydraulic Grade Line (HGL) are powerful graphical tools for
        understanding head distribution in a pipe system. The EGL must slope downward everywhere in the
        direction of flow, with additional sudden drops at each minor loss.
      </p>
      <DiagramEGLWithLosses/>
      <Table2 rows={[
        ["EGL slope (friction)",
`Slope = −h_f / L = −f · V²/(2gD)   [m/m]
Steeper in narrow pipes (high V) or rough pipes (high f)
Steeper section → more energy consumed per unit length`],
        ["Sudden EGL drops (minor losses)",
`Entrance: EGL drops by h_entry = K_entry · V²/(2g)
Expansion: EGL drops by (V₁−V₂)²/(2g)
Valve: EGL drops by K_valve · V²/(2g)
Total head at exit = H_reservoir − Σh_f − Σh_m`],
        ["HGL interpretation",
`HGL = EGL − V²/(2g)  (subtract velocity head)
HGL below pipe centreline: negative gauge pressure (possible cavitation)
Siphon operates with HGL below pipe over the crest
If HGL drops below P_v/ρg: cavitation occurs`],
        ["Three pipe problem — energy equation",
`Apply extended Bernoulli from point 1 to point 2:
H₁ + h_pump = H₂ + h_turbine + Σh_f + Σh_m
H = P/ρg + V²/2g + z  (total head at each point)
Solve for unknown: Q, D, L, or pump/turbine head`],
      ]}/>

      {/* ── Pipe Systems ── */}
      <h2 style={S.h2}>Pipe Systems — Series, Parallel &amp; Networks</h2>
      <p style={S.p}>
        Real installations combine multiple pipes. Series and parallel configurations follow simple rules.
        Full pipe networks (e.g. water distribution systems) require iterative methods such as the
        Hardy-Cross method to satisfy both continuity at junctions and head-loss compatibility around loops.
      </p>
      <DiagramPipeSystems/>
      <Table2 rows={[
        ["Series pipes — rules",
`Continuity: Q₁ = Q₂ = Q₃ = Q  (same flow rate throughout)
Head loss:  h_L,total = Σh_Lᵢ = Σfᵢ(Lᵢ/Dᵢ)(V²ᵢ/2g) + Σhₘᵢ
Different velocities in each pipe due to different diameters`],
        ["Parallel pipes — rules",
`Head loss:  h_LA = h_LB = h_LC  (same Δh across each branch)
Continuity: Q = Q_A + Q_B + Q_C
Solve: express each Qᵢ in terms of h_L, then sum to total Q`],
        ["Parallel pipe solution method",
`Assume h_L across parallel section
Compute Qᵢ = [h_L·2gDᵢ/(fᵢLᵢ)]^(1/2) · Aᵢ  for each branch
Sum Qᵢ; if ≠ Q_required, adjust h_L and iterate`],
        ["Three-reservoir problem",
`Three reservoirs connected at a junction J
Assume h_J (head at junction); flows in/out must sum to zero
Iterate h_J until continuity satisfied: ΣQ = 0 at J`],
        ["Hardy-Cross method (networks)",
`For each loop: ΣKQ|Q| (head loss around loop) = 0
Correction: ΔQ = −ΣKQ|Q| / (2Σ K|Q|)
Apply ΔQ to each pipe in loop; repeat until ΔQ < tolerance
Basis of modern water network simulation software (EPANET)`],
        ["Water hammer",
`Rapid valve closure creates pressure wave: ΔP = ρcΔV
c = speed of pressure wave = √(K/ρ) ≈ 1200 m/s (water in steel pipe)
Peak pressure can be many times normal operating pressure
Mitigated by slow valve closure, surge tanks, or pressure relief valves`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="PIPE FLOW & LOSSES — QUICK REFERENCE" items={[
        "Reynolds number:               Re = ρVD/μ = VD/ν",
        "Laminar friction factor:       f = 64/Re  (Re < 2300)",
        "Colebrook-White:               1/√f = −2 log(ε/3.7D + 2.51/Re√f)",
        "Swamee-Jain (explicit):        f = 0.25 / [log(ε/3.7D + 5.74/Re⁰·⁹)]²",
        "Darcy-Weisbach:                h_f = f(L/D)(V²/2g);  ΔP = f(L/D)(½ρV²)",
        "Minor loss:                    h_m = KV²/2g",
        "Sudden expansion (exact):      h_L = (V₁−V₂)²/2g  (Borda-Carnot)",
        "Entrance length (laminar):     L_e/D ≈ 0.06 Re",
        "Entrance length (turbulent):   L_e/D ≈ 4.4 Re^(1/6)",
        "Series pipes:                  Q = const;  h_L,total = Σh_Lᵢ",
        "Parallel pipes:                h_L = const;  Q = ΣQᵢ",
        "Water hammer pressure rise:    ΔP = ρcΔV;  c ≈ 1200 m/s (water/steel)",
      ]}/>
    </div>
  );
}